/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_increase_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate the percentage increase between two numbers. Enter the original and new value to see the percent increase instantly, with the formula and examples.`)
};

const es_pct_increase_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula el aumento porcentual entre dos números. Introduce el valor original y el nuevo para ver el aumento al instante, con la fórmula y ejemplos.`)
};

const de_pct_increase_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechne den prozentualen Anstieg zwischen zwei Zahlen. Gib Ausgangswert und neuen Wert ein und sieh sofort den Anstieg in Prozent, mit Formel und Beispielen.`)
};

const nl_pct_increase_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken de percentagestijging tussen twee getallen. Vul de oorspronkelijke en nieuwe waarde in voor direct de stijging in procenten, met formule en voorbeelden.`)
};

const fr_pct_increase_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez l'augmentation en pourcentage entre deux nombres. Entrez la valeur d'origine et la nouvelle valeur pour voir le résultat instantanément, avec la formule et des exemples.`)
};

const it_pct_increase_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola l'aumento percentuale tra due numeri. Inserisci il valore originale e quello nuovo per vedere subito l'aumento percentuale, con formula ed esempi.`)
};

const pt_br2_pct_increase_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule o aumento percentual entre dois números. Insira o valor original e o novo valor para ver o aumento percentual na hora, com a fórmula e exemplos.`)
};

const pt_pct_increase_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule o aumento percentual entre dois números. Insira o valor original e o novo valor para ver o aumento instantaneamente, com fórmula e exemplos.`)
};

const ja_pct_increase_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つの数値の間のパーセント増加を計算。元の値と新しい値を入力すると、計算式と例つきでパーセント増加がすぐに分かります。`)
};

const zh_pct_increase_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算两个数字之间的百分比增长。输入原始值和新值，即时查看百分比增长结果，并附有公式和示例。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_increase_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_increase_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_increase_meta_description", locale)
	if (locale === "en") return en_pct_increase_meta_description(inputs)
	if (locale === "es") return es_pct_increase_meta_description(inputs)
	if (locale === "de") return de_pct_increase_meta_description(inputs)
	if (locale === "nl") return nl_pct_increase_meta_description(inputs)
	if (locale === "fr") return fr_pct_increase_meta_description(inputs)
	if (locale === "it") return it_pct_increase_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_pct_increase_meta_description(inputs)
	if (locale === "pt") return pt_pct_increase_meta_description(inputs)
	if (locale === "ja") return ja_pct_increase_meta_description(inputs)
	return zh_pct_increase_meta_description(inputs)
};